import StaffType from "./actionTypes"



// function that called as action
const getList = data => ({
  type: StaffType.GET_STAFF_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: StaffType.GET_STAFF_LIST_SUCCESS,
  payload: data,
})


const StaffAction = {

  getList,
  getListSuccess,

}

export default StaffAction





